<template>
  <slot v-bind="{ saveForm, loading, canSetLink, selectTab, selectedTabId }"></slot>
</template>

<script>
import { FolderApi, DocumentApi } from '../../test-api/index.ts'
import bcFolderStore from '@/frontapp/store/bcFolder'
import bcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'
import Toast from '@/frontapp/mixins/actions/Toast'
import handleApiError from '../../utils/handleApiError'

const folderApi = new FolderApi({}, '/api/v2')
const documentApi = new DocumentApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false,
      selectedTabId: 'upload'
    }
  },
  props: {
    modalClosed: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapStores(bcFolderStore, bcSelectedStore),
    canSetLink() {
      return this.$formValues['frm-editForm-editForm-element_type'] === 'folder'
        && (!this.bcFolderStore.listChildren[this.$formValues['frm-editForm-editForm-id']]
        || this.bcFolderStore.listChildren[this.$formValues['frm-editForm-editForm-id']].length === 0)
    }
  },
  methods: {
    selectTab(id) {
      this.selectedTabId = id
      this.$formValues['frm-editForm-editForm-preview__url'] = null
      this.$formValues['frm-editForm-editForm-preview__meta_data'] = null

      if (id === 'text') {
        if (!this.$formValues['frm-editForm-editForm-icon_bg_color']) {
          this.$formValues['frm-editForm-editForm-icon_bg_color'] = document.documentElement.style.getPropertyValue('--primaryColor')
        }
      } else {
        if (!this.$formValues['frm-editForm-editForm-icon_text']) {
          this.$formValues['frm-editForm-editForm-icon_bg_color'] = null
        }
      }
    },
    async save() {
      if (this.$formValues['frm-editForm-editForm-element_type'] === 'folder') {
        const dto = {
          name: this.$formValues['frm-editForm-editForm-name'],
          link: this.$formValues['frm-editForm-editForm-link'],
          rank: this.$formValues['frm-editForm-editForm-rank'],
          preview__url: this.$formValues['frm-editForm-editForm-preview__url'],
          preview__meta_data: this.$formValues['frm-editForm-editForm-preview__meta_data'],
          parent__bc_folder_id:
            this.$formValues['frm-editForm-editForm-bc_folder_id']
              ? parseInt(this.$formValues['frm-editForm-editForm-bc_folder_id'])
              : 0,
          image__file_id:
            this.$formValues['frm-editForm-editForm-image__file_id']
              ? parseInt(this.$formValues['frm-editForm-editForm-image__file_id'])
              : null,
          header__file_id:
            this.$formValues['frm-editForm-editForm-header__file_id']
              ? parseInt(this.$formValues['frm-editForm-editForm-header__file_id'])
              : null,
          icon_text: this.$formValues['frm-editForm-editForm-icon_text']
            ? this.$formValues['frm-editForm-editForm-icon_text']
            : null,
          icon_bg_color: this.$formValues['frm-editForm-editForm-icon_bg_color']
            ? this.$formValues['frm-editForm-editForm-icon_bg_color']
            : null,
          icon_text_color: this.$formValues['frm-editForm-editForm-icon_text_color']
            ? this.$formValues['frm-editForm-editForm-icon_text_color']
            : null,
        }

        let response
        if (this.$formValues['frm-editForm-editForm-id']) {
          response = await handleApiError(() => folderApi.folderUpdate(
            this.$formValues['frm-editForm-editForm-id'],
            dto
          ))
        
        } else {
          response = await handleApiError(() => folderApi.folderCreate(dto))
        }

        this.bcFolderStore.updateFolder(response.data)
      
      } else {
        const dto = {
          name: this.$formValues['frm-editForm-editForm-name'],
          rank: this.$formValues['frm-editForm-editForm-rank'],
          preview__url: this.$formValues['frm-editForm-editForm-preview__url'],
          preview__meta_data: this.$formValues['frm-editForm-editForm-preview__meta_data'],
          bc_folder_id:
            this.$formValues['frm-editForm-editForm-bc_folder_id'] ? parseInt(this.$formValues['frm-editForm-editForm-bc_folder_id']) : 0,
          image__file_id:
            this.$formValues['frm-editForm-editForm-image__file_id'] ? parseInt(this.$formValues['frm-editForm-editForm-image__file_id']) : null,
          icon_text: this.$formValues['frm-editForm-editForm-icon_text']
            ? this.$formValues['frm-editForm-editForm-icon_text']
            : null,
          icon_bg_color: this.$formValues['frm-editForm-editForm-icon_bg_color']
            ? this.$formValues['frm-editForm-editForm-icon_bg_color']
            : null,
          icon_text_color: this.$formValues['frm-editForm-editForm-icon_text_color']
            ? this.$formValues['frm-editForm-editForm-icon_text_color']
            : null,
        }

        let response
        if (this.$formValues['frm-editForm-editForm-id']) {
          response = await handleApiError(() => documentApi.documentUpdate(
            this.$formValues['frm-editForm-editForm-id'],
            dto
          ))
        
        } else {
          response = await handleApiError(() => documentApi.documentCreate(dto))
        }

        this.bcFolderStore.updateDocument(response.data)
      }
    },
    saveForm(close) {
      this.loading = true
      this.save().then(() => {
        this.bcSelectedStore.reload()
        close()
        Toast(
          'success',
          this.$t('Changes were saved')
        )
        this.loading = false
      })
      return false
    }
  },
  watch: {
    modalClosed() {
      if (this.$formValues['frm-editForm-editForm-icon_text'] || this.$formValues['frm-editForm-editForm-icon_bg_color']) {
        this.selectedTabId = 'text'
      } else {
        this.selectedTabId = 'upload'
      }

      this.$formValues['frm-editForm-editForm-preview__url'] = null
      this.$formValues['frm-editForm-editForm-preview__meta_data'] = null
    }
  },
}
</script>

<style lang="scss"></style>
